import React, { Component } from 'react';
import img1 from '../img/img1.jfif';
import img2 from '../img/img2.jfif';
import img3 from '../img/img3.jfif';
import img4 from '../img/img4.jfif';
import img5 from '../img/img5.jfif';
import img6 from '../img/img6.jfif';
import img7 from '../img/img7.jfif';
import img8 from '../img/img8.jfif';
import img9 from '../img/img9.jfif';
import img10 from '../img/img10.jfif';
import img11 from '../img/img11.jfif';
import img12 from '../img/img12.jfif';
import { NavLink } from 'react-router-dom';
class Gallerycard extends Component {
    render() {
        return (
            <>
            <div className="container gallery-card">
                <div className="row">
                    <div className="col-12 mx-auto">
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img1} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>ALL MIN</h2>
                        <p>Unique Mineral Mixture For Aquaculture.</p>
                        <NavLink className="detail-btn" to="/product#allminCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img2} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>S-CONDITIONER</h2>
                        <p>Special products to condition the soil properly.</p>
                        <NavLink className="detail-btn" to="/product#sConditionerCard">read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img3} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>SOFTENER</h2>
                        <p>Special Water Softener.</p>
                        <NavLink className="detail-btn" to="/product#softnerCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img4} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>ZEO STAR</h2>
                        <p>Technical Grade Zeolite Added With Yucca.</p>
                        <NavLink className="detail-btn" to="/product#zeostarCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img5} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>PLANKTO BOOST</h2>
                        <p>Natural Plankton Developer.</p>
                        <NavLink className="detail-btn" to="/product#plankboostCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img6} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>VIT-C</h2>
                        <p>Unique Combination of Muiltivitamin</p>
                        <NavLink className="detail-btn" to="/product#vitCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img7} alt="gallery"style={{"width":"200px","height":"200px"}}  />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>LIVGEL</h2>
                        <p>Binder cum feed attractant added with Cod live oil </p>
                        <NavLink className="detail-btn" to="/product#livgelCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img8} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>YEAST PRO</h2>
                        <p>Best quality yeast for aquaculture.</p>
                        <NavLink className="detail-btn"  to="/product#yeastCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img9} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>BOTTOM CARE</h2>
                        <p>Concentrated water & soil probiotic.</p>
                        <NavLink className="detail-btn" to="/product#bottomCareCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img10} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>MOULT ALL</h2>
                        <p>Complete solution of moulting & gill chock.</p>
                        <NavLink className="detail-btn" to="/product#bottomCareCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img11} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>GASO CURE</h2>
                        <p>Best gas absorbent.</p>
                        <NavLink className="detail-btn"  to="/product#bottomCareCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                <div className="box col-lg-3 col-md-4 col-sm-10">
                    <div className="imgBox">
                        <img src={img12} alt="gallery" style={{"width":"200px","height":"200px"}} />
                    </div>
                    <div className="details">
                        <div className="contane">
                        <h2>GROWTH PLUS</h2>
                        <p>Super growth promoter & immuno modulator.</p>
                        <NavLink className="detail-btn" to="/product#bottomCareCard" >read more</NavLink>
                        </div>
                    </div>
                </div>
                
                    </div>
                </div>
               
            </div>
            </>
        )
    }
}

export default Gallerycard;
